import React, {useState} from "react";
import {Menu, MenuItem, IconButton, ListItemIcon, ListItemText, useTheme, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import {useNavigate, useLocation} from "react-router-dom";
import UpdateStatusDialog from "./update-status.dialog";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import UpdateIcon from "@mui/icons-material/Update";
import { useGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";

const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedContainer, setOpen, theme, customIconStyles, organizationId} = props;

    const navigate = useNavigate();

    const {hasPermission} = useGuard();
    

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
    
    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleUpdateStatus = () => {
        setSelectedContainer(data);
        setOpen(true);
    }

    const handleViewDetails = (e, data) => {
        if (organizationId) {
            navigate(`/organization/view/containers/view?org_uid=${organizationId}&id=${data.container_uid}`);

        } else {
            navigate(`/containers/view?id=${data.container_uid}`);
        }
    }

    const handleEditContainer = (e, data) => {
        if (organizationId) {
            navigate(`/organization/view/containers/edit?org_uid=${organizationId}&id=${data.container_uid}`);

        } else {
            navigate(`/containers/edit?id=${data.container_uid}`);
        }
    }

    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Details",
            onClick: (e) => handleViewDetails(e, data),
            requiredPermission: permissions.containers.VIEW_CONTAINER,
        },
        {
            icon: <BorderColorIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Edit Container",
            onClick: (e) => handleEditContainer(e, data),
            requiredPermission: permissions.containers.CHANGE_UPDATE_CONTAINER,
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main, fontSize: 23}} />,
            label: "Update Status",
            onClick: (e) =>  handleUpdateStatus(e),
            requiredPermission: permissions.containers.CHANGE_STATUS_CONTAINER,
        }
    ].filter((item) => hasPermission(item.requiredPermission))
    
    return (
        <>
            {menuItems.length > 0 &&
            <>
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
    
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{style: {maxHeight: 300}}}
                >
                    {menuItems?.map((item, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                handleClose();
                                item.onClick();
                            }}
                            sx={{}}
                        >
                            <ListItemIcon sx={customIconStyles}>
                                {item.icon}
                            </ListItemIcon>
                
                            <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                        </MenuItem>
                    ))}
                </Menu>
            </>
            }      
        </>
    )
}

const ListContainerComponent = (props) => {
    const {headers, data, isMobile, breakpoints} = props;

    const theme = useTheme();
    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [selectedContainer, setSelectedContainer] = useState();

    const organizationId = new URLSearchParams(location.search).get("org_uid");
    

    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((container) => (
                                <TableRow key={container.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                         {container.container_number?.length > 12
                                            ? container.container_number.slice(0, 15) + '...'
                                            : container.container_number
                                        }
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {container.type || "N / A"}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="containerStatus"
                                            label={(container.status === "In Port") ? "In Port" 
                                                : 
                                                    (container.status === "In Transit") ? "In Transit"
                                                :
                                                    (container.status === "Scheduled") ? "Scheduled"
                                                :
                                                    (container.status === "In CY/CD") ? "In CY/CD"
                                                :
                                                    (container.status === "Out of Port") ? "Out of Port"
                                                :
                                                    (container.status === "Decommissioned") ? "Decommissioned"
                                                :
                                                    container.status
                                            }
                                        />
                                    </TableCell>

                                    <TableCell align="start">
                                        <CustomMenuPopperComponent 
                                            data={container} 
                                            setSelectedContainer={setSelectedContainer}
                                            theme={theme}
                                            setOpen={setOpen}
                                            organizationId={organizationId}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No container data available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {open && 
                <UpdateStatusDialog 
                    open={open} 
                    setOpen={setOpen} 
                    selectedContainer={selectedContainer}
                />
            }
        </Paper>
    )
}

export default ListContainerComponent